import { ListQueryQualifier, MessageTemplateType } from "@tellescope/types-models";

export interface TemplateAudience {
  types: MessageTemplateType[];
  channels?: string[];
  userRoles?: string[];
  userTags?: string[];
  enduserCustomTypeId?: string;
}

const matchesOrUnrestricted = (field: string, values: string[]): Record<string, unknown> => ({
  $or: [{ [field]: { $in: values } }, { [field]: { $exists: false } }, { [field]: { $size: 0 } }],
});

const matchesUserTags = (userTags: string[]): Record<string, unknown> => {
  const oneOf: ListQueryQualifier = "One Of";
  const allOf: ListQueryQualifier = "All Of";

  return {
    $or: [
      { "forUserTags.values": { $exists: false } },
      { "forUserTags.values": { $size: 0 } },
      { "forUserTags.qualifier": oneOf, "forUserTags.values": { $in: userTags } },
      {
        "forUserTags.qualifier": allOf,
        $expr: { $setIsSubset: [{ $ifNull: ["$forUserTags.values", []] }, userTags] },
      },
    ],
  };
};

export const buildTemplateAudienceMdbFilter = (audience: TemplateAudience): Record<string, unknown> => {
  const conditions = [
    audience.userRoles?.length ? matchesOrUnrestricted("forRoles", audience.userRoles) : undefined,
    audience.channels?.length ? matchesOrUnrestricted("forChannels", audience.channels) : undefined,
    audience.enduserCustomTypeId ? matchesOrUnrestricted("forEntityTypes", [audience.enduserCustomTypeId]) : undefined,
    audience.userTags?.length ? matchesUserTags(audience.userTags) : undefined,
  ].filter((condition): condition is Record<string, unknown> => condition !== undefined);

  return {
    type: { $in: audience.types },
    hideFromCompose: { $nin: [true] },
    ...(conditions.length ? { $and: conditions } : {}),
  };
};
